/*
* Created on Apr 06, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';
import ic_device_d_layer_svg from "../../static/img/content/ic-device-d-layer.svg";
import ic_status_ok_svg from "../../static/img/utils/ic-status-ok.svg";
import ic_status_warning_svg from "../../static/img/utils/ic-status-warning.svg";
import {useTranslation} from "react-i18next";
import {useQuery} from "@tanstack/react-query";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";

const MainContentSummaryRowDeviceComponent = ({organization, goDevice}) => {
    const {t} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const organization_id = organization.organization_id;
    const {data} = useQuery({queryKey: [`/v1.2/device/summary`, organization_id],
        queryFn: async () => {
            const device_list = await OrganizationAPI.device.get('summary', {organization_id});
            return device_list.result;
        }
    });

    return (
        <div className="col-summary col-groups flex-default !w-16">
            <div className="l-section flex-1">
                <div className="section-title">
                    <span className="ic"><img src={ic_device_d_layer_svg} alt=""/></span>
                    <span className="label">{t('@Device@')}</span>
                </div>
                <div className="total-num">
                    <span onClick={(e)=>goDevice(e)}>{data ? data.count: 0}</span>
                    {data && data.count > 0 && (
                        <div className="comp-dropdown">
                            <ul className="comp-dropdown-menu add-scroll overlay-scroll">
                                <li className="section">
                                    {
                                        data.device_names.map((dev, index) => {
                                            return (
                                                <div className="section-items selection" key={index} onClick={(e)=>goDevice(e)}>
                                                    <div className="item-label">{dev}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MainContentSummaryRowDeviceComponent;